export type CropArea = {
    x: number
    y: number
    width: number
    height: number
}

export const getCroppedImg = (
    imageSrc: string,
    pixelCrop: CropArea,
): Promise<string> => {
    const image = new Image()
    image.crossOrigin = 'anonymous'

    return new Promise((resolve, reject) => {
        image.onload = () => {
            try {
                const srcX = Math.max(0, Math.round(pixelCrop.x))
                const srcY = Math.max(0, Math.round(pixelCrop.y))
                const srcRight = Math.min(image.naturalWidth, Math.round(pixelCrop.x + pixelCrop.width))
                const srcBottom = Math.min(image.naturalHeight, Math.round(pixelCrop.y + pixelCrop.height))
                const srcW = srcRight - srcX
                const srcH = srcBottom - srcY

                if (srcW <= 0 || srcH <= 0) {
                    reject(new Error('El área de recorte no contiene píxeles de la imagen'))
                    return
                }

                const canvas = document.createElement('canvas')
                canvas.width = srcW
                canvas.height = srcH

                const ctx = canvas.getContext('2d')
                if (!ctx) {
                    reject(new Error('Canvas context not available'))
                    return
                }

                ctx.drawImage(image, srcX, srcY, srcW, srcH, 0, 0, srcW, srcH)
                resolve(canvas.toDataURL('image/png'))
            } catch (err) {
                reject(err)
            }
        }

        image.onerror = () => {
            reject(new Error('No se pudo cargar la imagen para recortar'))
        }

        image.src = imageSrc
    })
}
